module.exports = __webpack_public_path__ + "static/media/trusted_site.1c29de9b.svg";